// extracted by mini-css-extract-plugin
export default {"number":"Results_number__8SyyM","executiveSystem":"Results_executiveSystem__GtaCb","name":"Results_name__DBBhh","grid":"Results_grid__M4Mkk"};